document.addEventListener('DOMContentLoaded', function() {
  // 詳細画面への遷移ボタンをクリックした時の処理
  document.addEventListener('click', async function(event) {
    // js-read を class に持ち、 data-id 属性を持つ a タグを closet で取得
    const target = event.target.closest('.js-read[data-id]');

    // a タグが取得できた場合
    if (target && target instanceof HTMLAnchorElement) {
      // クリック時の画面遷移を一時停止
      event.preventDefault();

      // 通知を既読にする
      await fetch(document.querySelector('meta[name="site-url"]').content+'announcement/read/'+target.dataset.id);

      // 結果に関わらず遷移(target属性が_blankの場合は新しいタブで開く)
      if (target.target === '_blank') {
        window.open(target.href);
      }
      else {
        location.href = target.href;
      }
    }
  });
});
